import * as Sentry from "@sentry/react";
import { Integration } from "@sentry/types";

const initSentry = () => {
  if (import.meta.env.ADMIN_ENV === "local") {
    return;
  }
  try {
    const integrations: Integration[] = [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ];
    if (import.meta.env.ADMIN_ENV !== "dev") {
      integrations.push(Sentry.captureConsoleIntegration());
    }
    Sentry.init({
      dsn: "https://cef1c9e6b83c31ba05d5922c4fd47718@o4506659244474368.ingest.us.sentry.io/4507548324986880",
      environment: import.meta.env.ADMIN_ENV,
      release: `${import.meta.env.ADMIN_VERSION}-${
        import.meta.env.ADMIN_BUILD_NUMBER
      }-${import.meta.env.ADMIN_ENV}`,
      integrations: integrations,
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  } catch (e) {
    console.error("An error occurred in Sentry init", e);
  }
};

export default initSentry;
